import {
  type ComponentProps, useMemo,
} from 'react';
import { TabsComponent } from '~/_shared/components/tabs/tabs.component';
import { notEmpty } from '~/_shared/utils/array/array.helpers';

export const SidebarTabsComponent = ({
  activeTabIndex,
  tabs,
  setActiveTabIndex,
}: {
  activeTabIndex?: ComponentProps<typeof TabsComponent>['activeTabIndex'];
  tabs: NonEmptyArray<{ name: string }>;
  setActiveTabIndex?: ComponentProps<typeof TabsComponent>['setActiveTabIndex'];
}) => {
  const tabsData = useMemo(() => (
    tabs.map((tab, index) => ({
      header: tab.name.toUpperCase(),
      index,
      testid: `map-key-tab-${index}`,
      child: <></>,
    }))
  ), [tabs]);

  if (!notEmpty(tabsData)) {
    return;
  }

  return (
    <TabsComponent
      hideContent
      activeTabIndex={activeTabIndex}
      data={tabsData}
      setActiveTabIndex={setActiveTabIndex}
    />
  );
};
